import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { selectDealerProfile } from 'src/app/common/store/state/app.state';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';

@Component({
    selector: 'app-dealer-alerts',
    templateUrl: './dealer-alerts.component.html',
    styleUrl: './dealer-alerts.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class DealerAlertsComponent {

  myProfile$: Observable<Dealer>;
  businessLine: CarBusinessLine = CarBusinessLine.BUY;
  @Input() dealerId: string = "";

  CarBusinessLine = CarBusinessLine;

  constructor(
      private store: Store,
      private route: ActivatedRoute
    ) {
        this.myProfile$ = this.store.select(selectDealerProfile);
  
      }

    ngOnInit() {

      this.route.data.subscribe(
        data => {
          this.businessLine = data['businessLine'];
          this.store.dispatch(DealerActions.fetchMyAlertsSubmit({businessLine: this.businessLine, dealerId: this.dealerId}));
        }
      )        
  } 
}
